module.exports = __webpack_public_path__ + "img/neck_img.517dcce0.png";